import { dispatch } from '@services/GlobalEventBus'

export default {
  spawn (componentName, params) {
    dispatch('modal:spawn', {
      modal: componentName,
      bind: {
        data: params,
        cb: (task) => {
          data.value = task
        }
      },
    })
  },

  close (componentName) {
    dispatch('modal:close', {
      modal: componentName,
    })
  },
}
